import {
    Text,
    Button,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    // CheckboxGroup,
    Input,
    FormControl,
    FormLabel,
    Checkbox,
    // TableContainer,
    // IconButton,
  } from "@chakra-ui/react";
  
  import React, { useEffect, useState } from "react";
  // import Strings from '../../config/Strings';
  import PaymentStrings from './PaymentStrings';

  export default function CancelAlert({
    disclosure,
    onCompleted,
  }) {
    const [isConfirmed, setConfirmed] = useState(false)
    return (
      <AlertDialog
        size={"xl"}
        isOpen={disclosure.isOpen}
        onClose={disclosure.onClose}
        closeOnOverlayClick={false}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {PaymentStrings.cancel_dialog.title}
            </AlertDialogHeader>
  
            <AlertDialogBody>
                <Text>{PaymentStrings.cancel_dialog.description}</Text>
                <FormControl mt={4}>
                    <FormLabel>
                    {PaymentStrings.cancel_dialog.confirm_label}
                    </FormLabel>
                    <Checkbox
                        isChecked={isConfirmed}
                        onChange={(e) => {
                            setConfirmed(e.target.checked);
                        }}
                        >
                        {PaymentStrings.cancel_dialog.confirm_checkbox}
                    </Checkbox>
                </FormControl>
            </AlertDialogBody>
            
            <AlertDialogFooter>
              <Button
                mr={4}
                colorScheme={"green"}
                onClick={() => {
                    onCompleted(false)
                    disclosure.onClose();
                }}
              >
                {PaymentStrings.cancel_dialog.back}
              </Button>
  
              <Button
                mr={4}
                colorScheme={"red"}
                disabled={!isConfirmed}
                isDisabled={!isConfirmed}
                onClick={() => {
                    onCompleted(true)
                    disclosure.onClose();
                }}
              > {PaymentStrings.cancel_dialog.cancel}
                
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    );
  }
  